import { Type } from '@sinclair/typebox';

export enum InstallationStatus {
  INSTALLATION = 'installation',
  NOT_SIGNAL_READY = 'not_signal_ready',
  OPERATIONAL = 'operational',
}

export const enum GFAP_SCHEMA_IDS {
  GET_GFAPS_RESPONSE = 'GfapSchema',
  FORM_DATA = 'FormDataSchema',
  POST_BATCHES = 'BatchesSuccessSchema',
  INSTALLATION_RESPONSE = 'InstallationResponseSchema',
  GET_FILTERED_BATCHES = 'FilteredBatchesSchema',
}

export const GET_GFAPS_RESPONSE = Type.Array(
  Type.Object(
    {
      id: Type.String({
        pattern: '^[A-Z]{2}[A-Z]{2}-[0-9]{6}$',
      }),
      status: Type.Union([
        Type.Literal(InstallationStatus.INSTALLATION),
        Type.Literal(InstallationStatus.NOT_SIGNAL_READY),
        Type.Literal(InstallationStatus.OPERATIONAL),
      ]),
      network_provider: Type.String({
        description: 'Network provider code',
        pattern: '^[A-Z]{2}$',
      }),
      activation_code: Type.String({
        description: 'Activation code for the GFAP',
        pattern: '^[A-Z0-9]{8}$',
      }),
      created_at: Type.String({
        format: 'date-time',
        description: 'Date and time when the GFAP was created',
      }),
      updated_at: Type.String({
        format: 'date-time',
        description: 'Date and time when the GFAP was last updated',
      }),
    },
    {
      $id: GFAP_SCHEMA_IDS.GET_GFAPS_RESPONSE,
    },
  ),
);

// Define the base response structure first
export const BASE_GFAP_RESPONSE = Type.Object({
  id: Type.String({
    pattern: '^[A-Z]{2}[A-Z]{2}-[0-9]{6}$',
  }),
  network_provider: Type.String({
    description: 'Network provider code',
    pattern: '^[A-Z]{2}$',
  }),
  status: Type.Union([
    Type.Literal(InstallationStatus.INSTALLATION),
    Type.Literal(InstallationStatus.NOT_SIGNAL_READY),
    Type.Literal(InstallationStatus.OPERATIONAL),
  ]),
  created_at: Type.String({
    format: 'date-time',
    description: 'Date and time when the GFAP was created',
  }),
  updated_at: Type.String({
    format: 'date-time',
    description: 'Date and time when the GFAP was last updated',
  }),
});

// Define the GET_GFAP_RESPONSE using a composite pattern approach
export const GET_GFAP_RESPONSE = Type.Intersect([
  BASE_GFAP_RESPONSE,
  Type.Partial(
    Type.Object({
      form_data: Type.Union([
        Type.Object({}, { additionalProperties: true }),
        Type.Null(),
      ]),
      redirect_url: Type.Union([Type.String(), Type.Null()]),
      activation_code: Type.String({
        description: 'Activation code for the GFAP',
        pattern: '^[A-Z0-9]{8}$',
      }),
    }),
  ),
]);

export const FORM_DATA_SCHEMA = Type.Object(
  {
    installationStatus: Type.Enum(InstallationStatus),
  },
  {
    additionalProperties: true,
    $id: GFAP_SCHEMA_IDS.FORM_DATA,
  },
);

export const POST_BATCHES_RESPONSE = Type.Array(
  Type.Object({
    id: Type.String(),
    activation_code: Type.String(),
    url: Type.String(),
  }),
  {
    $id: GFAP_SCHEMA_IDS.POST_BATCHES,
  },
);

export const INSTALLATION_RESPONSE_SCHEMA = Type.Object(
  {
    home_id: Type.String(),
    network_provider: Type.String(),
    status: Type.Enum(InstallationStatus),
    activation_code: Type.String(),
    form_data: Type.Union([
      Type.Record(Type.String(), Type.Unknown()),
      Type.Null(),
    ]),
    redirect_url: Type.Optional(Type.Union([Type.String(), Type.Null()])),
  },
  {
    $id: GFAP_SCHEMA_IDS.INSTALLATION_RESPONSE,
  },
);

export const GET_FILTERED_BATCHES_RESPONSE = Type.Array(
  Type.Object(
    {
      id: Type.String(),
      home_id: Type.String(),
      status: Type.Enum(InstallationStatus),
      network_provider: Type.String(),
      batch_id: Type.Number(),
      created_at: Type.String({ format: 'date-time' }),
      activation_code: Type.String(),
      form_data: Type.Union([
        Type.Object({}, { additionalProperties: true }),
        Type.Null(),
      ]),
      installation_transitioned_at: Type.String({ format: 'date-time' }),
    },
    {
      $id: GFAP_SCHEMA_IDS.GET_FILTERED_BATCHES,
    },
  ),
);
